import { render, staticRenderFns } from "./add-new-page.vue?vue&type=template&id=3f5030c0&scoped=true"
import script from "./add-new-page.vue?vue&type=script&lang=js"
export * from "./add-new-page.vue?vue&type=script&lang=js"
import style0 from "./add-new-page.vue?vue&type=style&index=0&id=3f5030c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5030c0",
  null
  
)

export default component.exports